import * as z from "../../..";
import * as ui from "../../../../app/core/ui";

var addExpressionView = (groupButtonId: number) =>  new ui.Container({
    id: `ExpressionDetailsContainer_${groupButtonId}`,
    style: "display: flex; margin-left: 35px;",
    components: [
        new ui.HTML({
            HTML: `<input type='text' id='FieldSearch${groupButtonId}' class='clearable-input user-grid-tab-filter-field-search' autocomplete='no!' />`
        }),
        new ui.DropDownList({
            id: `FilterType${groupButtonId}`,
            classes: "mar-t-5 mar-r-5",
            bsc: " ",
            bindValue: "Value",
            dataTextField: "Text",
            dataValueField: "Value"
        }),
        new ui.TextBox({
            id: `FilterValueInput${groupButtonId}`,
            classes: "mar-t-5 mar-r-5",
            bsc: " ",
            bindValue: "FilterValue",
        }),
        new ui.Container({
            id: `DateTimeFilterValueContainer${groupButtonId}`,
            classes: "mar-t-5 mar-r-5",
            components: [
                new ui.DateTimeInput({
                    id: `DateTimeFilterValueInput${groupButtonId}`,
                    bsc: " ",
                    bindValue: "FilterValue",
                })
            ]
        }),
        new ui.HTML({
            HTML: `<a id='RemoveExpression${groupButtonId}' class='mar-t-10 mar-l-10 mar-r-20 close'></a>`
        })
    ]
});

export default addExpressionView;
